import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';

/**
 * Client entry point.
 *
 * Express serves index.html for every non-API GET, so the browser router owns
 * every public path (spec section 12).
 */
export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
